import { useState } from "react";

const useFormData = (initialValues) => {
  const [data, setData] = useState(initialValues);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setData(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const resetForm = () => setData(initialValues);

  return [data, handleChange, resetForm, setData];
};

export default useFormData;
